<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
  >
    <path d="M0.832503 9.41395C0.0513572 8.633 0.0513558 7.36683 0.832502 6.58588L6.83417 0.585714C7.61531 -0.195237 8.8818 -0.195238 9.66295 0.585713L15.6646 6.58588C16.4458 7.36683 16.4458 8.633 15.6646 9.41395L9.66295 15.4141C8.8818 16.1951 7.61531 16.1951 6.83417 15.4141L0.832503 9.41395ZM1.5397 7.2929C1.14912 7.68337 1.14912 8.31646 1.5397 8.70693L7.54136 14.7071C7.93194 15.0976 8.56518 15.0976 8.95576 14.7071L14.9574 8.70693C15.348 8.31646 15.348 7.68337 14.9574 7.2929L8.95575 1.29273C8.56518 0.902256 7.93194 0.902256 7.54136 1.29273L1.5397 7.2929Z" />
  </svg>
</template>
